<ub-card [rounded]="true">
  <h3 class="t-upper t-weight--normal" title>
    {{ title }}
  </h3>
  <div actions>
    <button mat-button color="primary" type="button" (click)="selectWalkthroughs()">
      <mat-icon aria-label="settings" i18n-aria-label>settings</mat-icon>
    </button>
  </div>
  @if ((walkthroughs$ | async); as walkthroughs) {
    <div content>
      @for (walkthrough of walkthroughs; track walkthrough) {
        <div class="walkthrough">
          <h2>
            {{ walkthrough.title }}
          </h2>
          <div class="steps">
            <ub-stepper [steps]="ubSteps[walkthrough.orig._id]" [condensed]="true"></ub-stepper>
          </div>
        </div>
      }
      @if (walkthroughs.length === 0) {
        <div>
          <p i18n>
        No walkthroughs found.
      </p>
        </div>
      }
    </div>
  } @else {
    <div content>
      <p i18n>Loading your walkthroughs, please wait.</p>
    </div>
  }
  <div footer>
    @if (lastUpdated$ | async; as lastUpdated) {
      <span>
        <ng-container i18n>Last updated</ng-container>: {{ lastUpdated | date:'medium'}}
        <button mat-flat-button type="button" color="primary" (click)="onRefresh()" i18n>Refresh</button>
      </span>
    } @else {
      @if ((allWalkthroughs$ | async)?.length) {
        <span>
          <button mat-flat-button
            color="primary"
            type="button"
          (click)="selectWalkthroughs()" i18n>Select active walkthroughs</button>
        </span>
      }
    }
  </div>
</ub-card>

